angular.module('qkr').directive('componentFilter', () => ({
        restrict: 'EA',
        template: require('../../directives/merchant/component_filter_template.html'),
        scope: {
           comboA: '=',
           comboB: '=',
           comboC: '=',
           search: '=',
           dialFunc: '&',
           updateFunc: '&',
           fireFunc: '&'
        },

        link(scope, elem, attrs) {
            scope.$watchCollection('comboA', (newVal, oldVal) => {
                if (newVal == null || (newVal.list && newVal.list.length === 0)) {
                   scope.showComboA = false;
                } else {
                   scope.showComboA = true;
                }

                scope.fireFunc({newVal, oldVal});
            });

            scope.$watchCollection('comboB', (newVal, oldVal) => {
                if (newVal == null || (newVal.list && newVal.list.length === 0)) {
                    scope.showComboB = false;
                } else {
                    scope.showComboB = true;
                }

                scope.fireFunc({newVal, oldVal});
            });
            
            scope.$watchCollection('comboC', (newVal, oldVal) => {
                if (newVal == null || (newVal.list && newVal.list.length === 0)) {
                    scope.showComboC = false;
                } else {
                    scope.showComboC = true;
                }

                scope.fireFunc({newVal, oldVal});
            });

            scope.$watch('search', (newVal, oldVal) => {
                scope.fireFunc({newVal, oldVal});
            });
        }
    }));



// WEBPACK FOOTER //
// ./src/directives/merchant/component_filter.js